import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Dashboard APIs
export const getDashboardExecutive = () => axios.get(`${API}/dashboard/executive`);
export const getDashboardSales = () => axios.get(`${API}/dashboard/sales`);
export const getDashboardFinance = () => axios.get(`${API}/dashboard/finance`);
export const getDashboardProjects = () => axios.get(`${API}/dashboard/projects`);

// Leads APIs
export const getLeads = () => axios.get(`${API}/leads`);
export const createLead = (data) => axios.post(`${API}/leads`, data);
export const updateLead = (id, data) => axios.put(`${API}/leads/${id}`, data);
export const deleteLead = (id) => axios.delete(`${API}/leads/${id}`);
export const importLeadsCSV = (csvData) => axios.post(`${API}/leads/import-csv`, { csv_data: csvData });

// Opportunities APIs
export const getOpportunities = () => axios.get(`${API}/opportunities`);
export const createOpportunity = (data) => axios.post(`${API}/opportunities`, data);
export const updateOpportunity = (id, data) => axios.put(`${API}/opportunities/${id}`, data);
export const deleteOpportunity = (id) => axios.delete(`${API}/opportunities/${id}`);

// Quotations APIs
export const getQuotations = () => axios.get(`${API}/quotations`);
export const createQuotation = (data) => axios.post(`${API}/quotations`, data);
export const updateQuotation = (id, data) => axios.put(`${API}/quotations/${id}`, data);
export const convertQuotationToInvoice = (id) => axios.post(`${API}/quotations/${id}/convert-to-invoice`);
export const getQuotationPDF = (id) => axios.get(`${API}/quotations/${id}/pdf`, { responseType: 'blob' });

// Invoices APIs
export const getInvoices = () => axios.get(`${API}/invoices`);
export const createInvoice = (data) => axios.post(`${API}/invoices`, data);
export const updateInvoice = (id, data) => axios.put(`${API}/invoices/${id}`, data);
export const getInvoicePDF = (id) => axios.get(`${API}/invoices/${id}/pdf`, { responseType: 'blob' });

// Payments APIs
export const getPayments = () => axios.get(`${API}/payments`);
export const createPayment = (data) => axios.post(`${API}/payments`, data);

// Projects APIs
export const getProjects = () => axios.get(`${API}/projects`);
export const createProject = (data) => axios.post(`${API}/projects`, data);
export const updateProject = (id, data) => axios.put(`${API}/projects/${id}`, data);
export const deleteProject = (id) => axios.delete(`${API}/projects/${id}`);

// Tasks APIs
export const getTasks = (projectId) => axios.get(`${API}/tasks`, { params: projectId ? { project_id: projectId } : {} });
export const createTask = (data) => axios.post(`${API}/tasks`, data);
export const updateTask = (id, data) => axios.put(`${API}/tasks/${id}`, data);
export const deleteTask = (id) => axios.delete(`${API}/tasks/${id}`);
export const importTasksCSV = (csvData, projectId = null) => axios.post(`${API}/tasks/import-csv`, { csv_data: csvData, project_id: projectId });
export const importTasksExcel = (fileContent, projectId = null) => axios.post(`${API}/tasks/import-excel`, { file_content: fileContent, project_id: projectId });
export const sendTaskReminders = () => axios.post(`${API}/tasks/send-reminders`);
export const updateTaskReminderEmails = (taskId, emails) => axios.put(`${API}/tasks/${taskId}/reminder-emails`, emails);
export const getTasksByOwner = (ownerEmail) => axios.get(`${API}/tasks/by-owner/${encodeURIComponent(ownerEmail)}`);

// Grants APIs
export const getGrants = () => axios.get(`${API}/grants`);
export const createGrant = (data) => axios.post(`${API}/grants`, data);
export const updateGrant = (id, data) => axios.put(`${API}/grants/${id}`, data);

// Risks APIs
export const getRisks = (projectId) => axios.get(`${API}/risks`, { params: projectId ? { project_id: projectId } : {} });
export const createRisk = (data) => axios.post(`${API}/risks`, data);
export const updateRisk = (id, data) => axios.put(`${API}/risks/${id}`, data);

// AI APIs
export const generateAI = (prompt, context, type = 'general') => 
  axios.post(`${API}/ai/generate`, { prompt, context, type });

// Accounting APIs
export const getAccounts = () => axios.get(`${API}/accounts`);
export const createAccount = (data) => axios.post(`${API}/accounts`, data);
export const updateAccount = (id, data) => axios.put(`${API}/accounts/${id}`, data);
export const seedDefaultAccounts = () => axios.post(`${API}/accounts/seed-default`);

export const getJournalEntries = () => axios.get(`${API}/journal-entries`);
export const createJournalEntry = (data) => axios.post(`${API}/journal-entries`, data);
export const getAccountLedger = (code) => axios.get(`${API}/ledger/${code}`);

export const getTrialBalance = () => axios.get(`${API}/reports/trial-balance`);
export const getIncomeStatement = () => axios.get(`${API}/reports/income-statement`);
export const getBalanceSheet = () => axios.get(`${API}/reports/balance-sheet`);

// Purchase Orders APIs
export const getPurchaseOrders = () => axios.get(`${API}/purchase-orders`);
export const createPurchaseOrder = (data) => axios.post(`${API}/purchase-orders`, data);
export const updatePurchaseOrder = (id, data) => axios.put(`${API}/purchase-orders/${id}`, data);
export const approvePurchaseOrder = (id) => axios.post(`${API}/purchase-orders/${id}/approve`);
export const receiveGoods = (id, data) => axios.post(`${API}/purchase-orders/${id}/receive-goods`, data);
export const recordSupplierInvoice = (id, data) => axios.post(`${API}/purchase-orders/${id}/supplier-invoice`, data);

// Calendar APIs
export const getCalendarEvents = (startDate, endDate) => axios.get(`${API}/calendar/events`, { params: { start_date: startDate, end_date: endDate } });
export const createCalendarEvent = (data) => axios.post(`${API}/calendar/events`, data);
export const updateCalendarEvent = (id, data) => axios.put(`${API}/calendar/events/${id}`, data);
export const deleteCalendarEvent = (id) => axios.delete(`${API}/calendar/events/${id}`);
export const createEventFromInvoice = (invoiceId) => axios.post(`${API}/calendar/events/from-invoice/${invoiceId}`);

// Notification APIs
export const getNotifications = (status) => axios.get(`${API}/notifications`, { params: status ? { status } : {} });
export const sendEmailNotification = (data) => axios.post(`${API}/notifications/send-email`, data);
export const sendWhatsAppNotification = (data) => axios.post(`${API}/notifications/send-whatsapp`, data);
export const sendOverdueReminder = (invoiceId) => axios.post(`${API}/notifications/overdue-reminder/${invoiceId}`);

// Client APIs
export const getClients = (status, industry) => axios.get(`${API}/clients`, { params: { status, industry } });
export const getClient = (id) => axios.get(`${API}/clients/${id}`);
export const createClient = (data) => axios.post(`${API}/clients`, data);
export const updateClient = (id, data) => axios.put(`${API}/clients/${id}`, data);
export const deleteClient = (id) => axios.delete(`${API}/clients/${id}`);
export const getClientInvoices = (id) => axios.get(`${API}/clients/${id}/invoices`);
export const convertLeadToClient = (leadId) => axios.post(`${API}/clients/convert-from-lead/${leadId}`);
export const getClientStatementPDF = (id) => axios.get(`${API}/clients/${id}/statement/pdf`, { responseType: 'blob' });
